import { SubscriptionStatus } from "@/enums/stripe";
import type { AgencyStatusResponse } from "@/types/agencies";
import { isEuropeRegion } from "@/utils/common/region";
import type { User } from "@/utils/common/userComparison";

const CANNY_APP_ID = "6679b7fcbb6ee9e80d74a55c";

type CannyIdentifyUser = {
  email: string;
  name: string;
  id: string;
  companies: Array<{
    id: string | undefined;
    name: string | undefined;
    customFields: {
      orgId: string | null | undefined;
      plan: SubscriptionStatus | undefined;
      isFreeTrial: boolean;
    };
  }>;
};

type CannyClient = (
  action: "identify",
  payload: { appID: string; user: CannyIdentifyUser }
) => void;

type CannyGlobal = typeof globalThis & {
  Canny?: CannyClient;
};

export function canUseCannyFeatures(
  region: string | undefined = process.env.NEXT_PUBLIC_REGION
): boolean {
  return !isEuropeRegion(region);
}

export function identifyCannyUser(
  user: User,
  status?: AgencyStatusResponse | null,
  region: string | undefined = process.env.NEXT_PUBLIC_REGION,
  canny: CannyClient | undefined = (globalThis as CannyGlobal).Canny
): void {
  if (!canUseCannyFeatures(region) || !canny) return;

  canny("identify", {
    appID: CANNY_APP_ID,
    user: {
      email: user.email,
      name: user.name,
      id: user.id,
      companies: [
        {
          id: user.agencyId,
          name: user.agencyId,
          customFields: {
            orgId: user.orgId,
            plan: status?.status,
            isFreeTrial:
              status?.status === SubscriptionStatus.none ||
              status?.status === SubscriptionStatus.trialing,
          },
        },
      ],
    },
  });
}
